import { proxy } from 'valtio'

const superliteProductChoices = proxy({
  choices: [
    {
      identifier: { name: 'Motorcycles', index: 0 },

      id: [3019, 4081],
      testingId: [3019],

      ribNumber: [1, 2, 3, 4, 5, 6, 7],
      midPanel: false,
      badges: [
        { name: 'enjoyMfg', label: 'enjoyMfg', mode: 'enjoyMfg', abrv: 'ENJ' },
        { name: 'Beta', label: 'Beta', mode: 'beta', abrv: 'BET' },
        { name: 'Gasgas', label: 'Gasgas', mode: 'gasgas', abrv: 'GG' },
        { name: 'Honda', label: 'Honda', mode: 'honda', abrv: 'HON' },
        {
          name: 'Husqvarna',
          label: 'Husqvarna',
          mode: 'husqvarna',
          abrv: 'HUS',
        },
        { name: 'Kawasaki', label: 'Kawasaki', mode: 'kawasaki', abrv: 'KAW' },
        { name: 'KTM', label: 'KTM', mode: 'ktm', abrv: 'KTM' },
        { name: 'Suzuki', label: 'Suzuki', mode: 'suzuki', abrv: 'SUZ' },
        { name: 'Yamaha', label: 'Yamaha', mode: 'yamaha', abrv: 'YAM' },
        { name: 'Bolt', label: 'Bolt', mode: 'bolt', abrv: 'BLT' },
        { name: 'None', label: 'None', mode: 'none', abrv: 'None' },
      ],
      newBadge: false,
      make: [
        [
          'Ducati',
          'DUC',
          [
            ['Desmo 250', [['2026', '568', 7, 'motorcycle', 'large']]],
            ['Desmo 450', [['2025-2026', '568', 7, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Gasgas',
          'GAS',
          [
            ['EC 250', [['2024-2026', '404', 7, 'motorcycle', 'large']]],
            ['EC 300', [['2024-2026', '404', 7, 'motorcycle', 'large']]],
            ['EC 450F', [['2024-2026', '404', 7, 'motorcycle', 'large']]],
            ['ES 350', [['2024-2026', '404', 7, 'motorcycle', 'large']]],
            ['ES 500', [['2024-2026', '404', 7, 'motorcycle', 'large']]],
            ['EX 250', [['2024-2026', '404', 7, 'motorcycle', 'large']]],
            ['EX 250F', [['2024-2026', '404', 7, 'motorcycle', 'large']]],
            ['EX 300', [['2024-2026', '404', 7, 'motorcycle', 'large']]],
            ['EX 350F', [['2024-2026', '404', 7, 'motorcycle', 'large']]],
            ['MC 125', [['2024-2026', '404', 7, 'motorcycle', 'large']]],
            ['MC 150', [['2024-2026', '404', 7, 'motorcycle', 'large']]],
            ['MC 250', [['2024-2026', '404', 7, 'motorcycle', 'large']]],
            ['MC 250F', [['2024-2026', '404', 7, 'motorcycle', 'large']]],
            ['MC 300', [['2024-2026', '404', 7, 'motorcycle', 'large']]],
            ['MC 450F', [['2024-2026', '404', 7, 'motorcycle', 'large']]],
            ['MC 50', [['2024-2026', '422', 4, 'motorcycle', 'large']]],
            ['MC 65', [['2024-2026', '426', 5, 'motorcycle', 'large']]],
            ['MC 85', [['2025-2026', '458', 7, 'motorcycle', 'large']]],
            ['MC-E 2', [['2024-2026', '431', 4, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Honda',
          'HON',
          [
            ['CRF 110F', [['2019-2026', '234', 5, 'motorcycle', 'large']]],
            ['CRF 125F', [['2019-2026', '234', 5, 'motorcycle', 'large']]],
            ['CRF 150R', [['2007-2026', '50', 7, 'motorcycle', 'large']]],
            ['CRF 250F', [['2019-2026', '248', 7, 'motorcycle', 'large']]],
            ['CRF 250R', [['2022-2026', '233', 6, 'motorcycle', 'large']]],
            ['CRF 250RX', [['2022-2026', '233', 6, 'motorcycle', 'large']]],
            ['CRF 300F', [['2026', '248', 7, 'motorcycle', 'large']]],
            ['CRF 450R', [['2021-2026', '233', 6, 'motorcycle', 'large']]],
            ['CRF 450RL', [['2021-2026', '155', 8, 'motorcycle', 'large']]],
            ['CRF 450RX', [['2021-2026', '233', 6, 'motorcycle', 'large']]],
            ['CRF 450X', [['2019-2026', '155', 8, 'motorcycle', 'large']]],
            ['CRF 50F', [['2004-2026', '106', 4, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Husqvarna',
          'HUS',
          [
            ['150 TE', [['2024-2026', '329', 7, 'motorcycle', 'large']]],
            ['250 FC', [['2023-2026', '329', 7, 'motorcycle', 'large']]],
            ['250 TE', [['2024-2026', '329', 7, 'motorcycle', 'large']]],
            ['300 TX', [['2024-2026', '329', 7, 'motorcycle', 'large']]],
            ['350 FC', [['2023-2026', '329', 7, 'motorcycle', 'large']]],
            ['350 FE', [['2024-2026', '329', 7, 'motorcycle', 'large']]],
            ['350 FX', [['2024-2026', '329', 7, 'motorcycle', 'large']]],
            ['450 FC', [['2023-2026', '329', 7, 'motorcycle', 'large']]],
            ['450 FE', [['2024-2026', '329', 7, 'motorcycle', 'large']]],
            ['501 FE', [['2024-2026', '329', 7, 'motorcycle', 'large']]],
            ['TC 125', [['2023-2026', '329', 7, 'motorcycle', 'large']]],
            ['TC 150', [['2026', '329', 7, 'motorcycle', 'large']]],
            ['TC 250', [['2023-2026', '329', 7, 'motorcycle', 'large']]],
            ['TC 300', [['2026', '329', 7, 'motorcycle', 'large']]],
            ['TC 50', [['2024-2026', '430', 4, 'motorcycle', 'large']]],
            ['TC 65', [['2024-2026', '445', 7, 'motorcycle', 'large']]],
            ['TC 85', [['2025-2026', '463', 7, 'motorcycle', 'large']]],
          ],
        ],
        [
          'KTM',
          'KTM',
          [
            ['125 SX', [['2023-2026', '352', 7, 'motorcycle', 'large']]],
            ['125 XC', [['2023-2026', '352', 7, 'motorcycle', 'large']]],
            ['150 SX', [['2025-2026', '352', 7, 'motorcycle', 'large']]],
            ['150 XC', [['2024-2026', '352', 7, 'motorcycle', 'large']]],
            ['150 XC-W', [['2024-2026', '352', 7, 'motorcycle', 'large']]],
            ['250 SX', [['2023-2026', '352', 7, 'motorcycle', 'large']]],
            ['250 SXF', [['2023-2026', '352', 7, 'motorcycle', 'large']]],
            ['250 XC', [['2023-2026', '352', 7, 'motorcycle', 'large']]],
            ['250 XC-F', [['2023-2026', '352', 7, 'motorcycle', 'large']]],
            ['250 XC-W', [['2024-2026', '352', 7, 'motorcycle', 'large']]],
            ['250 XC-W TPI', [['2024-2026', '352', 7, 'motorcycle', 'large']]],
            ['300 SX', [['2023-2026', '352', 7, 'motorcycle', 'large']]],
            ['300 XC', [['2023-2026', '352', 7, 'motorcycle', 'large']]],
            ['300 XC-W', [['2024-2026', '352', 7, 'motorcycle', 'large']]],
            ['300 XC-W TPI', [['2024-2026', '352', 7, 'motorcycle', 'large']]],
            ['350 EXC-F', [['2024-2026', '352', 7, 'motorcycle', 'large']]],
            ['350 SXF', [['2023-2026', '352', 7, 'motorcycle', 'large']]],
            ['350 XC-F', [['2023-2026', '352', 7, 'motorcycle', 'large']]],
            ['450 SMR', [['2024-2026', '352', 7, 'motorcycle', 'large']]],
            ['450 SXF', [['2023-2026', '352', 7, 'motorcycle', 'large']]],
            ['450 XC-F', [['2023-2026', '352', 7, 'motorcycle', 'large']]],
            ['50 SX', [['2024-2026', '422', 4, 'motorcycle', 'large']]],
            ['500 EXC-F', [['2024-2026', '352', 7, 'motorcycle', 'large']]],
            ['65 SX', [['2024-2026', '426', 5, 'motorcycle', 'large']]],
            ['SX 85', [['2025-2026', '458', 7, 'motorcycle', 'large']]],
            ['SX-E 3', [['2025-2026', '422', 4, 'motorcycle', 'large']]],
            ['SX-E 5', [['2025-2026', '422', 4, 'motorcycle', 'large']]],
            ['SX-E2', [['2025-2026', '431', 4, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Kawasaki',
          'KAW',
          [
            ['KLR 650', [['2022-2026', '438', 7, 'motorcycle', 'large']]],
            ['KLX 110', [['2004-2026', '71', 4, 'motorcycle', 'large']]],
            ['KLX 140', [['2008-2026', '176', 7, 'motorcycle', 'large']]],
            ['KX 112', [['2022-2026', '83', 6, 'motorcycle', 'large']]],
            ['KX 250F', [['2021-2026', '174', 7, 'motorcycle', 'large']]],
            ['KX 250X', [['2022-2026', '174', 7, 'motorcycle', 'large']]],
            ['KX 450F', [['2019-2026', '174', 7, 'motorcycle', 'large']]],
            ['KX 450X', [['2024-2026', '174', 7, 'motorcycle', 'large']]],
            ['KX 65', [['2002-2026', '71', 4, 'motorcycle', 'large']]],
            ['KX 85', [['2014-2026', '83', 6, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Suzuki',
          'SUZ',
          [
            ['DR 650SE', [['2006-2026', '244', 7, 'motorcycle', 'large']]],
            ['DR-Z4S', [['2025-2026', '517', 7, 'motorcycle', 'large']]],
            ['DRZ 125', [['2003-2026', '170', 8, 'motorcycle', 'large']]],
            ['RMZ 250', [['2019-2026', '163', 7, 'motorcycle', 'large']]],
            ['RMZ 450', [['2018-2026', '163', 7, 'motorcycle', 'large']]],
          ],
        ],
        ['TM', 'TM', [['85 MX', [['2013-2026', '501', 7, 'motorcycle', 'large']]]]],
        [
          'Triumph',
          'TRI',
          [
            ['TF 250-C', [['2025-2026', '467', 8, 'motorcycle', 'large']]],
            ['TF 250-E', [['2025-2026', '467', 8, 'motorcycle', 'large']]],
            ['TF 250-X', [['2024-2026', '467', 8, 'motorcycle', 'large']]],
            ['TF 450-C', [['2025-2026', '467', 8, 'motorcycle', 'large']]],
            ['TF 450-E', [['2025-2026', '467', 8, 'motorcycle', 'large']]],
            ['TF 450-RC', [['2024-2026', '467', 8, 'motorcycle', 'large']]],
            ['TF 450-X', [['2024-2026', '467', 8, 'motorcycle', 'large']]],
          ],
        ],
        [
          'Yamaha',
          'YAM',
          [
            ['PW 50', [['1981-2026', '91', 4, 'motorcycle', 'large']]],
            ['TTR 110', [['2008-2026', '104', 4, 'motorcycle', 'large']]],
            ['TTR 125', [['2008-2026', '147', 6, 'motorcycle', 'large']]],
            ['TTR 230', [['2005-2026', '97', 7, 'motorcycle', 'large']]],
            ['TTR 50', [['2004-2026', '105', 4, 'motorcycle', 'large']]],
            ['TW 200', [['1987-2026', '271', 7, 'motorcycle', 'large']]],
            ['WR 250F', [['2025-2026', '375', 7, 'motorcycle', 'large']]],
            ['WR 450F', [['2024-2026', '375', 7, 'motorcycle', 'large']]],
            ['YZ 125', [['2022-2026', '311', 7, 'motorcycle', 'large']]],
            ['YZ 125X', [['2023-2026', '311', 7, 'motorcycle', 'large']]],
            ['YZ 250', [['2022-2026', '311', 7, 'motorcycle', 'large']]],
            ['YZ 250F', [['2024-2026', '375', 7, 'motorcycle', 'large']]],
            ['YZ 250X', [['2023-2026', '311', 7, 'motorcycle', 'large']]],
            ['YZ 450F', [['2023-2026', '375', 7, 'motorcycle', 'large']]],
            ['YZ 65', [['2018-2026', '188', 6, 'motorcycle', 'large']]],
            ['YZ 85', [['2022-2026', '319', 6, 'motorcycle', 'large']]],
          ],
        ],
      ],
    },
  ],
})

export { superliteProductChoices }
